<template>
	<v-container grid-list-md>
		<v-layout row wrap >
      <v-flex xs12 md12>
       <!-- {{ index }} {{instructor}} -->
      </v-flex>
      <v-flex xs11 md11>
        <v-autocomplete
          :loading="loading"
          v-model="instructor.person"
          :items="personItems"
          color="blue"
          item-value="id"
          item-text="fullname"
          label="ผู้สอน/วิทยากร"
          :rules="[v => !!v || 'ไม่สามารถเป็นค่าว่าง']" 
          required
          :disabled="disabled"
          hide-details
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md12>
        <v-layout row wrap>
          <v-flex xs3 md2>
            <v-checkbox 
                label=""  
                hint="วิทยากร" 
                persistent-hint 
                v-model="instructor.guest" 
                color="orange darken-3" 
                :disabled="disabled"
                
                ></v-checkbox>
          </v-flex>
          <v-flex xs3 md2>
            <v-checkbox 
                label=""
                hint="ที่จอดรถ" 
                persistent-hint  
                v-model="instructor.isParking" 
                color="red darken-3" 
                v-if="instructor.guest" 
                :disabled="disabled"
                
                ></v-checkbox>
          </v-flex>
          <v-flex xs3 md2>
            <v-checkbox 
                label="" 
                hint="ค่าตอบแทน" 
                persistent-hint 
                v-model="instructor.isWage" 
                color="green darken-3" 
                v-if="instructor.guest"
                :disabled="disabled" 
                ></v-checkbox>
          </v-flex>
          <v-flex xs3 md2>
            <v-checkbox 
                label="" 
                hint="หนังสือขออนุมัติ" 
                persistent-hint 
                v-model="instructor.isLetter" 
                color="indigo lighten-2" 
                v-if="instructor.guest" 
                :disabled="disabled"
                ></v-checkbox>
          </v-flex>
          <v-flex xs12 md12 v-if="instructor.isWage">
            <v-layout row class="pa-2">
            <span class="green--text pr-3">ค่าตอบแทนสุทธิ</span>
            <v-text-field
              v-model="instructor.wageAmount"
              label="จำนวน"
              :rules="[v => !!v || 'ไม่สามารถเป็นค่าว่าง']" 
              required
              solo            
              :disabled="!instructor.isWage || disabled"
            ></v-text-field>
            </v-layout>
          </v-flex>
          <v-flex xs12 md12 v-if="instructor.isLetter">
            <v-layout row class="pa-2">
            <span class="indigo--text pr-3">หนังสือขออนุมัติ</span>
            <v-text-field
              v-model="instructor.authorizedPerson"
              label="ผู้บังคับบัญชา"
              class="input-group--focused"
              :rules="[v => !!v || 'ไม่สามารถเป็นค่าว่าง']" 
              required
              :disabled="disabled"
            ></v-text-field>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['disabled', 'instructor', 'index'],
	data () {
		return {
      loading: false,
      // personItems: []
		}
	},
	mounted () {
		// this.loadPersons ()
	},
  computed: {
    ...mapGetters({
      personItems: 'person/personItems'
    })
  },
	methods: {
		loadPersons () {
      this.loading = true
      this.$store.dispatch('person/loadItems')
        .then((response) => {
          // console.log('reload:', response.data )
          this.loading = false
          this.personItems = response.data
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    }
	},
  watch: {
    'instructor.guest' (val) {
      if(!val) {
        this.instructor.isParking = false
        this.instructor.isWage = false
        this.instructor.isLetter = false
        this.instructor.authorizedPerson = null
      }
    },
    'instructor.isLetter' (val) {
      if(!val) this.instructor.authorizedPerson = null
    },
    'instructor.isWage' (val) {
      if(!val) this.instructor.wageAmount = 0
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/forms/instructor.vue